module.exports = __webpack_public_path__ + "img/mile1m-m@2.170868b7.webp";